import React from 'react';
import { Header } from '../components/Header';
import { HeroSection } from '../components/HeroSection';
import { CapabilitiesSection } from '../components/CapabilitiesSection';
import { ParallaxBanner } from '../components/ParallaxBanner';
import { ServicesSection } from '../components/ServicesSection';
import { AboutSection } from '../components/AboutSection';
import { ContactSection } from '../components/ContactSection';
import { Footer } from '../components/Footer';
export function HomePage() {
  return <div className="min-h-screen bg-offwhite text-gray-900 font-sans selection:bg-accent selection:text-white" data-id="element-204">
      <Header data-id="element-205" />
      <main data-id="element-206">
        <HeroSection data-id="element-207" />
        <CapabilitiesSection data-id="element-208" />
        <ParallaxBanner data-id="element-209" />
        <ServicesSection data-id="element-210" />
        <AboutSection data-id="element-211" />
        <ContactSection data-id="element-212" />
      </main>
      <Footer data-id="element-213" />
    </div>;
}